import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface SidebarStore {
  isExpanded: boolean;
  isHovered: boolean;
  toggleIsExpanded: () => void;
  setIsExpanded: (bool: boolean) => void;
  setIsHovered: (bool: boolean) => void;
}

export const useSidebarStore = create<SidebarStore>()(
  devtools(
    persist(
      (set) => ({
        isExpanded: true,
        isHovered: false,
        toggleIsExpanded: () => set((store) => ({ isExpanded: !store.isExpanded })),
        setIsExpanded: (bool) => set(() => ({ isExpanded: bool })),
        setIsHovered: (bool) => set(() => ({ isHovered: bool })),
      }),
      { name: 'ems-sidebar-store' }
    )
  )
);
